'use strict';
import { CountUp } from 'countup.js';

class NumberBlock {
    constructor(countItems) {
        for (var i = 0; i < countItems.length; i++) {
            const item = countItems[i];
            const observer = new IntersectionObserver(this.handleIntersection);
            observer.observe(item.parentElement);
        }
    }

    handleIntersection(entries) {
        entries.map((entry) => {
            if (entry.isIntersecting) {
                const numberElement = entry.target.querySelector('.numbercard__number');

                if (numberElement && numberElement.textContent === '0') {
                    const options = { separator: ' ', useEasing: false, startVal: 0 };
                    const countUp = new CountUp(numberElement, numberElement.dataset.counter, options);
                    countUp.start();
                    entry.target.classList.add('numbercard--visible')
                }
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const countItems = document.querySelectorAll('.numbercard__number');
    if (countItems) {
        new NumberBlock(countItems);
    }
});